// packages/main-app/src/utils/globalState.ts
import { initGlobalState, MicroAppStateActions } from "qiankun";
import { getStoredLanguage, LanguageType } from "@eweadn-qiankun/shared-i18n";
import { readWallpaperPreference } from "./wallpaperPreference";

export interface GlobalState {
  theme: "light" | "dark";
  language: LanguageType;
  userInfo?: any;
  token?: string | null;
  deviceType: string;
  currentDeviceSystem: number;
  wallpaperEnabled: boolean;
}

const getInitialWallpaperEnabled = (): boolean => {
  try {
    const preference = readWallpaperPreference();
    if (preference.wallpaperEnabled && preference.wallpaperUrl) return true;

    const rawStore = localStorage.getItem("global-store");
    if (!rawStore) return false;
    const store = JSON.parse(rawStore);
    const state = store?.state || {};
    return Boolean(state.wallpaperEnabled && state.wallpaperUrl);
  } catch {
    return false;
  }
};

/** 子应用 bundle 也会间接 import 本模块，不可再次 initGlobalState，否则会覆盖主应用通信通道 */
const createNoopGlobalStateActions = (): MicroAppStateActions => ({
  setGlobalState: () => false,
  onGlobalStateChange: () => () => false,
  offGlobalStateChange: () => false,
});

const isQiankunSubApp =
  typeof window !== "undefined" &&
  Boolean(
    (window as Window & { __POWERED_BY_QIANKUN__?: boolean })
      .__POWERED_BY_QIANKUN__
  );

const actions: MicroAppStateActions = isQiankunSubApp
  ? createNoopGlobalStateActions()
  : initGlobalState({
      theme: (localStorage.getItem("app-theme") as "light" | "dark") || "light",
      language: getStoredLanguage(),
      userInfo: JSON.parse(localStorage.getItem("userInfo") || "null"),
      token: localStorage.getItem("token"),
      deviceType: "",
      currentDeviceSystem: 0,
      wallpaperEnabled: getInitialWallpaperEnabled(),
    });

if (!isQiankunSubApp) {
  console.log("[globalState] qiankun 全局状态已初始化");
}

export { actions };
export default actions;
